import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';

const styles = {
  root: {
    '& .top-section': {
      backgroundSize: 'cover',
      background: `url(${Images.BottleLayer})`,
      backgroundRepeat: 'no-repeat',
      '& .content': {
        paddingTop: 24,
        paddingBottom: 16,
        position: 'relative',
        '& .owning': {
          borderRadius: 4,
          padding: '8px 12px',
          background: Colors.white,
        },
      },
    },
    '& .headline': {
      color: '#fff',
      fontWeight: '700',
      lineHeight: '160%',
    },
  },
};

export default styles;
